import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';

import ModalWithConfirmation from 'components/ModalWithConfirmation';
import LoadingGate from 'components/LoadingGate';
import SprayEventFinalForm from '../SprayEventFinalForm';
import { EDIT_SPRAY_EVENT_MODAL } from '../../constants';
import { makeSelectSprayEventIsCompleted } from '../../selectors';

interface ConnectedProps {
    isOpen?: boolean;
    isCompleted: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = ConnectedProps & DispatchProps;

export class SprayEventEditModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [EDIT_SPRAY_EVENT_MODAL]: undefined,
            sprayEventUuid: undefined
        });
    };

    render(): React.ReactElement {
        const { isOpen, isCompleted } = this.props;

        return (
            <LoadingGate namespace="SPRAY_EVENTS_LOAD">
                <RoleGate requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}>
                    <ModalWithConfirmation
                        size="fullscreen"
                        open={isOpen}
                        centered={false}
                        onCloseClick={this.handleClose}
                        closeIcon
                        className="spray-event-modal"
                        showConfirmation={!isCompleted}
                    >
                        <ErrorBoundary
                            namespace="sprayEventEditModal"
                            FallbackComponent={<ErrorBoundaryAlert />}
                        >
                            <SprayEventFinalForm
                                title="Edit Spray Schedule"
                                isEditing
                            />
                        </ErrorBoundary>
                    </ModalWithConfirmation>
                </RoleGate>
            </LoadingGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue(EDIT_SPRAY_EVENT_MODAL),
    isCompleted: makeSelectSprayEventIsCompleted()
});

export default connect(mapStateToProps, {
    updateQueryString
})(SprayEventEditModalComponent);
